import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {KindOfUpload} from '../upload/helpers/kind-of-upload.enum';
import {WorkflowService} from '../../../services/apiServices/business/workflow-service';
import {UserManagementService} from '../../../services/apiServices/business/user-management.service';
import {AuthenticationService} from '../../../services/apiServices/security/authentication.service';
import {KindOfAcceptedFilesService} from '../../../services/apiServices/business/kind-of-accepted-files.service';
import {User} from '../../../model/user';
import {environment} from '../../../../environments/environment';
import {MenuItem} from 'primeng/api';
import {CommonService} from "../../../services/apiServices/business/common.service";

/**
 * represent the left container of the application (upload and search)
 */
@Component({
  selector: 'app-left-container',
  templateUrl: './left-container.component.html',
  styleUrls: ['./left-container.component.scss']
})
export class LeftContainerComponent implements OnInit {

  /**
   * the action asked by user regarding upload
   */
  @Output()
  upload: EventEmitter<string>;
  @Output()
  modalTitleExpress: EventEmitter<string>;
  @Output()
  displayUserManagementEvent: EventEmitter<boolean>;

  /**
   * List of upload possibilities
   */
  public uploadItems: MenuItem[];
  envName = environment.name;

  /**
   * label for upload as letter
   */
  private lreLabel: string;
  /**
   * label for upload as letter
   */
  private letterLabel: string;

  /**
   * label for upload as mailing
   */
  private mailingLabel: string;
  /**
   * label for upload as spool
   */
  private spoolLabel: string;
  /**
   * If the user wants to open the Validation or Signature Modal
   */
  public displayValidationAndSignature: boolean;
  public displayUserManagement: boolean;


  /**
   * List of workflows items
   */
  public listOfWorkflows: any[];
  public currentUser: User;
  public showExpress: boolean;
  public AdminNumen: boolean;
  public isAdminUsers: boolean;
  public enableActions: boolean;
  private successRequestTitle: string;
  private successRequestMessage: string;
  private errorRequestTitle: string;
  private errorRequestMessage: string;
  public displayExportPopup: boolean;
  public exportedData: any;

  constructor(private translate: TranslateService, private workflowService: WorkflowService,
              private kindOfAcceptedFilesService: KindOfAcceptedFilesService,
              private userManagementService: UserManagementService, private authService: AuthenticationService,
              private commonService: CommonService) {
    this.upload = new EventEmitter();
    this.displayUserManagementEvent = new EventEmitter();
    this.modalTitleExpress = new EventEmitter();
  }

  /**
   * get Translations and set uploadItems
   */
  public ngOnInit(): void {
    this.initPermissions();
    this.displayValidationAndSignature = false;
    this.displayUserManagement = false;
    this.getTradForComponent();
    this.initDepositOptions();
    this.authService.isLogged.subscribe(evnt => {
      this.initPermissions()
    });

    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((label: string) => {
      this.successRequestTitle = label;
    });
    this.translate.get('TOASTER.SUCESS_REQUEST_OK').subscribe((label: string) => {
      this.successRequestMessage = label;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((label: string) => {
      this.errorRequestTitle = label;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_MESSAGE').subscribe((label: string) => {
      this.errorRequestMessage = label;
    });
  }

  initPermissions() {
    this.isAdminUsers = this.authService.isAdminUser();
    this.currentUser = this.authService.getCurrentUser();
    this.AdminNumen = this.authService.isAdminNumen();
    this.showExpress = (this.currentUser && this.currentUser.isAuthorizedExpress) || (this.currentUser && this.currentUser.admin);
    this.enableActions = this.currentUser.permissions.trackingDepot.withAction;
  }

  private initDepositOptions() {
    this.uploadItems = [];
    if (this.currentUser.permissions.webDepotUnit.available) {
      this.uploadItems.push({
        label: this.letterLabel, icon: 'fa fa-envelope',
        command: () => {
          this.openUpload(KindOfUpload.LETTER);
        }
      });
    }
    if (this.currentUser.permissions.webDepotMailing.available) {
      this.uploadItems.push({
        label: this.mailingLabel, icon: 'fa fa-envelope-o',
        command: () => {
          this.openUpload(KindOfUpload.MAILING);
        }
      });
    }
    if (this.currentUser.permissions.webDepotSpool.available) {
      this.uploadItems.push({
        label: this.spoolLabel, icon: 'fa fa-users',
        command: () => {
          this.openUpload(KindOfUpload.SPOOL);
        }
      });
    }
    if (this.currentUser.permissions.webDepotLRE.available) {
      this.uploadItems.push({
        label: this.lreLabel, icon: 'fa fa-at',
        command: () => {
          this.openUpload(KindOfUpload.LRE);
        }

      });
    }
  }

  /**
   * Get translations for the component
   */
  private getTradForComponent(): void {
    this.letterLabel = this.translate.instant('LEFT.CONTAINER_COMPONENT.OPTION_LETTER_LABEL');
    this.mailingLabel = this.translate.instant('LEFT.CONTAINER_COMPONENT.OPTION_MAILING_LABEL');
    this.spoolLabel = this.translate.instant('LEFT.CONTAINER_COMPONENT.OPTION_SPOOL_LABEL');
    this.lreLabel = this.translate.instant('LEFT.CONTAINER_COMPONENT.OPTION_LRE_LABEL');
  }

  /**
   * handle event emitting for upload
   * @param {number} kindOfUpload
   */
  public openUpload(kindOfUpload: string): void {
    this.upload.emit(kindOfUpload);
    this.modalTitleExpress.emit(kindOfUpload);
  }

  /**
   * handle opening of signature and validation component
   */
  public openValidAndSign(): void {
    this.workflowService.getlistOfWorkflows().subscribe(res => {
      this.listOfWorkflows = res;
      this.displayValidationAndSignature = true;
    });
  }

  /*
    show user managment dialog
   */
  public openUserManager(): void {
    this.displayUserManagement = true;
    this.displayUserManagementEvent.emit(true);
  }

  public closeUserManager(): void {
    this.displayUserManagement = false;
    this.displayUserManagementEvent.emit(false);
  }

  exportWso2(): void {
    this.userManagementService.exportWso2(this.currentUser.idCustomer).subscribe({
      next: response => {

        this.exportedData = {
          usersCreated: (response[0] || []).map(obj => {
            const key = Object.keys(obj)[0];
            return { key, value: obj[key] };
          }),
          usersExisted: (response[1] || []).map(obj => {
            const key = Object.keys(obj)[0];
            return { key, value: obj[key] };
          }),
          usersFailure: (response[2] || []).map(obj => {
            const key = Object.keys(obj)[0];
            return { key, value: obj[key] };
          })
        };

        this.displayExportPopup = true;
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successRequestTitle,
          detail: this.successRequestMessage
        });
      },
      error: error => {
        console.error('Erreur lors de l’exportation vers WSO2:', error);
        this.commonService.addToast({
          life: 3000,
          severity: 'error',
          summary: this.errorRequestTitle,
          detail: this.errorRequestMessage
        });
      }
    });
  }
}
